// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"744682e0","590":"de180d1e","655":"5c097da1"}[chunkId] + ".chunk.js";
};